export const currentPathname = window.location.pathname;